import React, { forwardRef, useEffect, useRef } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { FormGroup, Label } from "reactstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";

const MultipleSelectField = ({
  input,
  label,
  values,
  meta: { touched, error },
  placeholder,
  disabled,
  onClear,
  setOnClear,
  isRequired,
  ...otherProps
}: any) => {

  const typeaheadRef = useRef<any>(null);
  const flip = otherProps.flip || false;
  useEffect(()=>{
    if(setOnClear){
      setOnClear(false)
      typeaheadRef.current.clear();
    }
  },[onClear])

  return (
    <FormGroup className="mb-4">
      <Label for="state">{label}
      {isRequired && <span className="input-required">*</span>}
      </Label>
      <Typeahead
        id="basic-typeahead-multiple"
        className="multiSelectField"
        labelKey="text"
        multiple
        placeholder={placeholder}
        onChange={(event: any) => {
          setTimeout(() => {
            input.onChange(event);
          }, 100);
        }}
        options={values}
        selected={input.value}
        disabled={disabled}
        ref={typeaheadRef}
        flip={flip}
        // dropup={true}
      />
      {touched && (values === "" || error) ? (
        <h6 className="danger">{error}</h6>
      ) : (
        ""
      )}
    </FormGroup>
  );
};
export default forwardRef(MultipleSelectField);